import * as Sentry from '@sentry/browser';

if (!Sentry.isInitialized()) {
  Sentry.init({
    dsn: 'https://795f39c2649721d8e06e125c5da0cdc3@o103309.ingest.us.sentry.io/4508184464588800',
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/www\.exrny\.com\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

(function () {
  let searchParams = new URLSearchParams(window.location.search);
  let result = {};

  let keys = {
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_content: 'utm_content',
    adgroup: 'ad_group',
    utm_term: 'utm_term',
    device: 'device',
    matchtype: 'match_type',
    targetid: 'target_id',
    loc_physical_ms: 'loc_physical_ms',
    loc_interest_ms: 'loc_interest_ms',
    network: 'network',
    devicemodel: 'device_model',
    adposition: 'ad_position',
    campaign_id: 'campaign_id',
    ad_id: 'ad_id',
    adgroup_id: 'ad_group_id',
    placement: 'placement',
    adname: 'ad_name',
  };

  for (let [k, v] of searchParams) {
    if (k in keys) {
      result[keys[k]] = v;
    } else if (k == 'gclid') {
      result.click_source = 'google';
      result.click_id = v;
    } else if (k == 'msclid') {
      result.click_source = 'microsoft';
      result.click_id = v;
    } else if (k == 'fbclid') {
      result.click_source = 'facebook';
      result.click_id = v;
    }
  }

  if (Object.keys(result).length === 0 && result.constructor === Object) return;

  localStorage.setItem('tracking', JSON.stringify(result));
})();
